export default __webpack_public_path__ + "static/media/team_hover.54f61d00.png";